import { render, staticRenderFns } from "./exhibition-release.vue?vue&type=template&id=816bb4ae&scoped=true&"
import script from "./exhibition-release.vue?vue&type=script&lang=js&"
export * from "./exhibition-release.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-release.vue?vue&type=style&index=0&id=816bb4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816bb4ae",
  null
  
)

export default component.exports